import { render } from "./Moose.vue?vue&type=template&id=f8aace6a"
import script from "./Moose.vue?vue&type=script&lang=js"
export * from "./Moose.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__